import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RootState, Site, UUID } from '@umanforge/common';
import { SftpService } from 'services/sftp.service';
import { ModifySite } from 'interfaces/api_site.interfaces';
import { GlobalService } from 'services/global.service';

export type ExportFilters = {
  filterSites?: UUID[];
  filterSectors?: UUID[];
};

export function useSftpSection(
  site : Site, setSftpActivated: ( item:boolean ) => void,
  setDefaultSftpStatus: ( item:boolean ) => void,
  setModifySite: ( item: ModifySite ) => void,
  modifySite: ModifySite,
  newEmails: string[],
  setNewEmails: ( item: string[] ) => void,
  removedEmails: string[],
  setRemovedEmails: ( item: string[] ) => void
) {

  const dispatch = useDispatch();
  const token = useSelector( ( state: RootState ) => { return state.token.value; } );

  const [ currentEmails, setCurrentEmails ] = useState<string[]>( [] );

  const [ newEmail, setNewEmail ] = useState<string>( '' );
  const [ isModalOpen, setIsModalOpen ] = useState<boolean>( false );

  const [ isActive, setIsActive ] = useState<boolean>( false );
  const [ isLoading, setIsLoading ] = useState<boolean>( true );

  useEffect( () => {
    init();
  }, [ site, token ] );

  const init = () => {
    setIsLoading( true );
    SftpService.getSftpStatusOfSite( site.id, token, dispatch )
      .then( result => {
        setSftpActivated( result );
        setDefaultSftpStatus( result );
        setIsActive( result );
        setIsLoading( false );
      } );

    SftpService.getSftpErrorEmailsOfSite( site.id, token, dispatch )
      .then( result => {
        setCurrentEmails( result );
      } );
  };

  const onSftpStatusChanged = ( value: boolean ) => {
    setSftpActivated( value );
    if ( value != isActive && value === true ) {
      modifySite.sftpPublicKey = site.sftpPublicKey ?? undefined;
      setModifySite( structuredClone( modifySite ) );
    }
  };

  const onAddEmailClick = ( email: string ) => {
    const removedIndexList = removedEmails.findIndex( removedEmail => { return email === removedEmail; } );
    if ( removedIndexList === -1 ) {
      setNewEmails( [ ...newEmails, email ] );
    } else {
      onCancelRemoveEmailClick( removedIndexList );
    }
  };
  const onCancelAddEmailClick = ( index: number ) => {
    setNewEmails( newEmails.filter( ( _, idx ) => { return index != idx; } ) );
  };
  const onRemoveEmailClick = ( index : number ) => {
    setRemovedEmails( [ ...removedEmails, currentEmails[ index ] ] );
  };
  const onCancelRemoveEmailClick = ( index: number ) => {
    setRemovedEmails( removedEmails.filter( ( _, idx ) => { return index != idx; } ) );
  };

  const checkEmail = ( value: string ) => {
    let error = null;
    if ( value === '' ) {
      error = 'the_field_must_not_be_empty';
    } else if ( !GlobalService.validateEmail( value ) ) {
      error = 'please_enter_an_email_address';
    } else if ( newEmails.includes( value ) || currentEmails.filter( email => { return !removedEmails.includes( email ); } ).includes( value ) ) {
      error = 'email_already_used';
    }
    return error;
  };


  return {
    isLoading,
    isActive,
    onSftpStatusChanged,
    isModalOpen, setIsModalOpen,
    currentEmails,
    onAddEmailClick, onCancelAddEmailClick,
    onRemoveEmailClick, onCancelRemoveEmailClick,
    newEmail, setNewEmail,
    checkEmail
  };
}